import { render } from "./basket.vue?vue&type=template&id=64081a3a&scoped=true"
import script from "./basket.vue?vue&type=script&lang=js"
export * from "./basket.vue?vue&type=script&lang=js"

import "./basket.vue?vue&type=style&index=0&id=64081a3a&lang=scss&scoped=true"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64081a3a"]])

export default __exports__